<template>
  <div >
    <el-dialog :visible.sync="dialogVisible" width="40%" :show-close="false" class="createProductDialog">
      <div class="title">
        <p>生成预算商品</p>
        <p>(您将按照下方信息生成预算商品，订单产生后若无后台供应商接单，则订单自动失效)</p>
      </div>
      <div class="content">
        <p>您想从&nbsp;{{resourceObj.nameCn}}&nbsp;采购得产品描述：</p>
        <el-input v-model="resourceObj.nameCn"></el-input>
        <el-input v-model="stockObj.productNameCn"></el-input>
        <el-input v-model="stockObj.productDesc"></el-input>
        <div>
          <span>采购预算</span>
          <el-input v-model="stockObj.price" size="mini"></el-input>
          <currency-autocomplete :obj="stockObj"></currency-autocomplete>
          <span>采购数量</span>
          <el-input v-model="stockObj.stockNumber" size="mini" style="width:0.7rem"></el-input>
          总采购预算：{{stockObj.price*stockObj.stockNumber}}{{stockObj.currency}}
        </div>
        <div>
          <span>销售价格</span>
          <el-input v-model="stockObj.salePrice" size="mini"></el-input>
          总销售价格：{{stockObj.salePrice*stockObj.stockNumber}}{{stockObj.currency}}
        </div>
        <div>
          <el-button @click="save">保存并加入行程轴</el-button>
          <el-button @click="dialogVisible=false">关闭</el-button>
        </div>
      </div>
    </el-dialog>
    <add-site-product-dialog v-if="resourceObj.state===1" ref="addProductDialog" :chenckBudgteObj="chenckBudgteObj" 
      @closeDialog="dialogVisible=false" :keyStr="keyStr"></add-site-product-dialog>
    <add-hotel-product-dialog v-if="resourceObj.state===0" ref="addProductDialog" @closeDialog="dialogVisible=false"></add-hotel-product-dialog>
    <add-traffic-product-dialog v-if="(resourceObj.isLinkProduct==-1&&(resourceObj.state===3||resourceObj.state===5))||(resourceObj.isLinkProduct==3||resourceObj.state===5)" 
      ref="addProductDialog" @closeDialog="dialogVisible=false"></add-traffic-product-dialog>
    <add-meal-product-dialog v-if="resourceObj.state===4||resourceObj.isLinkProduct==4" ref="addProductDialog" @closeDialog="dialogVisible=false"></add-meal-product-dialog>
  </div>
</template>

<script>
import CurrencyAutocomplete from '../../../../common/currencyAutocomplete.vue';
import AddSiteProductDialog from './addSiteProductDialog.vue';
import addHotelProductDialog from './addHotelProductDialog.vue'
import AddMealProductDialog from './addMealProductDialog.vue'
import addTrafficProductDialog from './addTrafficProductDialog.vue'
import PlanApi from '@/components/Api/PlanApi.js'
import { refresh } from '../../../js/function'
export default {
  data(){
    return{
      dialogVisible:false,
      resourceObj:{},
      stockObj:{},
      chenckBudgteObj:{}
    }
  },
  methods:{
    beforeOpen(item,item1,data){
      this.dialogVisible = true;
      this.resourceObj = item
      this.stockObj = JSON.parse(JSON.stringify(item1))
      this.$set(this.stockObj,'price',null)
      this.$set(this.stockObj,'salePrice',null)
      this.$set(this.stockObj,'stockNumber',null)
      this.$set(this.stockObj,'currency',null)
      this.chenckBudgteObj = data
    },
    save(){
      this.$set(this.stockObj,'isChange',true)
      if(this.resourceObj.state==1){
        this.$refs.addProductDialog.beforeOpen(this.resourceObj,this.stockObj)
      }else if(this.resourceObj.state==7||this.resourceObj.state==2||this.resourceObj.state==6){
        if(!(this.stockObj.priceList&&this.stockObj.priceList.length>0)){
          this.stockObj.priceList = [{ priceCompany:'团' }]
        }
        var arr = [{
          stockId:this.stockObj.stockId?this.stockObj.stockId:0,
          stockNumber:this.stockObj.stockNumber,
          productId:0,
          productName:this.stockObj.productNameCn,
          stockPrice:this.stockObj.price,
          ratio:this.stockObj.salePrice,
          currency:this.stockObj.currency,
          priceResult:this.stockObj
        }]
        var dateList=[{
          cityId:this.resourceObj.cityId,
          cityName:this.resourceObj.cityName,
          cityNameEn:this.resourceObj.cityNameEn,
          planDate:this.searchDate,
        }]
        var obj = {
          budgetMainId:this.$store.state.budgetMainId,
          planId:this.$store.state.planId,
          state:this.resourceObj.state,
          productType:10,
          resourceId:this.resourceObj.id,
          resourceNameCn:this.resourceObj.nameCn,
          resourceNameEn:this.resourceObj.nameEn,
          planDayList:dateList,
          key:this.keyStr,
          details:arr
        }
        new PlanApi('plan').budgetAdd(obj).then(res => {
          if (res.status == 200) {
            this.$message({type:"success",message:"添加成功"})
            this.dialogVisible = false
            this.$emit("closeDialog");
            refresh(res.data,this.$store.state.planId,this.$store.state.budgetMainId,'refresh')
          }else{
            this.$message({type:"error",message:res.statusText})
          }
        })
      }else{
        this.$refs.addProductDialog.openDialog(this.resourceObj,this.stockObj,this.chenckBudgteObj,this.keyStr)
      }
    }
  },
  components:{CurrencyAutocomplete, AddSiteProductDialog,addHotelProductDialog,AddMealProductDialog,addTrafficProductDialog},
  props:{
    keyStr:{
      type:String,
      default:''
    },
    searchDate:{
      type:String,
      default:''
    }
  }
}
</script>

<style lang="scss" scoped>
.createProductDialog{
  /deep/ .el-dialog__body,/deep/ .el-dialog__header{
    padding: 0 !important;
  }
  .title{
    background: #e1f5f3;
    padding: 0.12rem 0.4rem;
    font-weight: bold;
    color: black;
    >p:first-child{
      font-size: 0.18rem;
      margin-bottom: 0.05rem;
    }
  }
  .content{
    color: black;
    padding: 0.1rem 0.6rem;
    >div:last-child{
      justify-content: center;
      margin-top: 0.2rem;
      >button{
        background: #E1F5F3;
        color: #148276;
      }
    }
    >div{
      margin-top: 0.1rem;
      display: flex;
      align-items: center;
      >div{
        width: 1.2rem;
        margin-right:0.1rem;
      }
      >span{
        margin-right:0.1rem;
      }
    }
  }
}
</style>